import { render } from "./leave-types.vue?vue&type=template&id=aadb7708"
import script from "./leave-types.vue?vue&type=script&lang=js"
export * from "./leave-types.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__